var _excluded = ["bg", "color", "onClose", "textStyle", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { CloseButton, deprecatedPropType, Flex, Text } from 'pcln-design-system';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
var Title = styled(Text).withConfig({
  displayName: "ModalHeader__Title",
  componentId: "sc-jkop2n-0"
})(["display:flex;align-items:center;"]);
var StyledCloseButton = styled(CloseButton).withConfig({
  displayName: "ModalHeader__StyledCloseButton",
  componentId: "sc-jkop2n-1"
})(["height:24px;width:24px;svg{vertical-align:top;}&:focus{box-shadow:none;outline:none;}"]);

var ModalHeader = function ModalHeader(_ref) {
  var bg = _ref.bg,
      color = _ref.color,
      onClose = _ref.onClose,
      textStyle = _ref.textStyle,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, _extends({
    align: "center",
    alignItems: "center",
    color: color,
    bg: bg,
    borderRadius: "xl",
    height: "40px",
    rounded: "top"
  }, props), title && /*#__PURE__*/React.createElement(Title, {
    textStyle: textStyle
  }, title), onClose && /*#__PURE__*/React.createElement(StyledCloseButton, {
    onClick: onClose,
    ml: "auto"
  }));
};

ModalHeader.displayName = ModalHeader;
ModalHeader.propTypes = _objectSpread(_objectSpread({}, space.propTypes), {}, {
  bg: deprecatedPropType('color'),
  color: PropTypes.string,
  onClose: PropTypes.func,
  textStyle: PropTypes.string,
  title: PropTypes.string
});
ModalHeader.defaultProps = {
  bg: 'primary.base',
  color: 'text.lightest',
  px: 3,
  textStyle: 'heading6'
};
export default ModalHeader;